<template>
  <el-popover placement="bottom-end" trigger="hover" :disabled="disabled">
    <div class="directory" v-for="dict in menu.children" :key="dict.name" style="max-width: 420px">
      <template v-if="dict.children">
        <div class="title">
          {{ $t('menu::' + dict['actionCode'].split('::').slice(1).join('::')) }}
        </div>
        <div class="menuList">
          <div
            v-for="item in dict.children"
            @click="toUrl(item)"
            :key="item.actionCode"
            class="menu"
            :class="dict.name.split('::').slice(0)"
          >
            <i class="iconfont" :class="item.icon"></i>
            <span>
              {{ $t('menu::' + item['actionCode'].split('::').slice(1).join('::')) }}
            </span>
          </div>
        </div>
      </template>
    </div>
    <el-link :underline="false" slot="reference" class="dict">
      {{ $t(menu.actionCode ? 'menu::' + menu['actionCode'].split('::').slice(1).join('::') : '') }}
      <i class="iconfont icondown-circle-01"></i>
    </el-link>
  </el-popover>
</template>

<script>
export default {
  props: {
    menu: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    disabled() {
      return this.menu.children && this.menu.children.length
        ? this.menu.children.every(el => (el.children ? !el.children.length : true))
        : true
    },
  },
  methods: {
    toUrl(item) {
      if (item.url) {
        this.$router.push({ path: item.url })
      } else {
        this.$router.push({ name: item.actionCode.split('::').pop() })
      }
      this.$store.commit('menu.setCollapse', true)
    },
  },
}
</script>

<style scoped lang="scss">
.dict {
  background: #f7f8fa;
  border-radius: 14px;
  padding: 6px 14px;
  font-size: 13px !important;
  font-weight: normal;
  color: #54627c;
}
.icondown-circle-01 {
  font-size: 13px;
}
.directory {
  .title {
    color: #010517;
    font-weight: bold;
    font-size: 12px;
    margin-bottom: 16px;
  }
  .menuList {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    transform: translate(-12px, 0);
    .menu {
      background: #fffbf1;
      //   padding: 16px;
      margin-left: 16px;
      width: 80px;
      height: 80px;
      cursor: pointer;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-bottom: 16px;
      .iconfont {
        font-size: 28px !important;
        margin-bottom: 8px;
      }
      span {
        font-size: 12px;
      }
    }
    .shop-data {
      background: rgba(54, 109, 255, 0.05);
      .iconfont {
        color: #5177f6 !important;
      }
    }
    .system-set {
      background: #f4fcf9;
      .iconfont {
        color: #59c175 !important;
      }
    }
    .param-setting {
      background: #fffbf1;
      .iconfont {
        color: #efa73f !important;
      }
    }
  }
}
.directory + .directory {
  margin-top: 16px;
}
</style>
